import { computed } from "vue";
import useCreateComponentConfig from "../../../composables/useCreateComponentConfig.js";
import { EDividerElements } from "../types.js";
export default function useDividerConfig(props) {
  const rootClasses = useRootConfig(props);
  return {
    root: rootClasses
  };
}
function useRootConfig(props) {
  const { setBase, addVariant, getClasses } = useCreateComponentConfig();
  setBase(
    EDividerElements.ROOT,
    /* tw */
    props.orientation === "horizontal" ? (
      /* tw */
      "border-t-thin h-0 w-full"
    ) : (
      /* tw */
      "border-l-thin h-full min-h-5 w-0"
    )
  );
  addVariant(EDividerElements.ROOT, "subtlest", {
    base: (
      /* tw */
      `border-neutral-subtlest`
    ),
    states: {}
  });
  addVariant(EDividerElements.ROOT, "strong", {
    base: (
      /* tw */
      `border-neutral-strong`
    ),
    states: {}
  });
  const rootClasses = computed(() => {
    return getClasses(EDividerElements.ROOT, props.variant);
  });
  return rootClasses.value;
}
